import { Skeleton } from '@/components/ui/Skeleton';
import { useAdminPlans } from '@/hooks/useAdminBilling';
import { PlanEditor } from '../components/PlanEditor';
import { PricingRulesEditor } from '../components/PricingRulesEditor';
import type { PlanConfig } from '@/types/admin.types';
import { toast } from 'sonner';

export function PricingConfigPage() {
  const { data, isLoading } = useAdminPlans();
  // Service returns PlanConfig[] directly
  const plans = data || [];

  const handleEdit = (plan: PlanConfig) => {
    toast.info(`Édition du plan ${plan.name} (fonctionnalité à venir)`);
  };

  return (
    <div className="space-y-6">
      <div><h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Tarification</h1><p className="text-sm text-neutral-500">Configuration des plans et règles de prix</p></div>
      {isLoading ? (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3"><Skeleton className="h-48" /><Skeleton className="h-48" /><Skeleton className="h-48" /></div>
      ) : (
        <PlanEditor plans={plans} onEdit={handleEdit} />
      )}
      <PricingRulesEditor />
    </div>
  );
}
